import { Component, Input } from '@angular/core';
import { ModalController } from '@ionic/angular/lazy';
import { ImageGalleryModal } from '../image-gallery-modal/image-gallery.modal';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'in2-thumbnails-gallery',
  templateUrl: './thumbnails-gallery.component.html',
  styleUrls: ['./thumbnails-gallery.component.scss'],
  standalone: false,
})
export class ThumbnailsGalleryComponent {
  @Input() public photos: string[] = [];
  @Input() public maxThumbnails: number = 4;
  @Input() public inputThumbnailSize = '';

  constructor(
    public readonly sanitizer: DomSanitizer,
    private readonly modalController: ModalController
  ) {}

  public async openPictureModal(index: number) {
    const modal: HTMLIonModalElement = await this.modalController.create({
      component: ImageGalleryModal,
      componentProps: {
        externalUrls: this.photos,
        startIndex: index,
      },
      backdropDismiss: false,
    });

    await modal.present();
  }
}
